<template>
  <div class="aliyun-oss" :id="btn_select">
    <el-dialog title="确认上传" :append-to-body="true" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="visible" :before-close="onBeforeCloseHandler" width="30%" center>
      <transition-group tag="ul" name="el-list" :class="[
        'el-upload-list',
        { 'is-disabled': disabled }]">
        <li v-for="(file, index) in files" :key="index" :class="['el-upload-list__item', 'is-' + file.status == 5 ? 'success' : 'finish']"
          tabindex="0">
          <a class="el-upload-list__item-name" @click="handleClick(file)">
            <i class="el-icon-document"></i>{{file.name}}
          </a>
          <label class="el-upload-list__item-status-label" style="{display: 'inline'}">
            <i :class="{
              'el-icon-success': file.status === 5,
              'el-icon-loading': file.status === 2,
              'el-icon-error': file.status === 4,
              'el-icon-upload-success': true
            }"></i>
          </label>
          <i class="el-icon-close" v-if="!disabled || file.status !== 5" @click="doRemoveFielHandler(file)"></i>
          <el-progress :percentage="file.percent"></el-progress>
        </li>
      </transition-group>
      <div :id="randomId"></div>

      <span slot="footer" class="dialog-footer">
        <el-button :id="btn_start" @click="onStartHandler">开始上传</el-button>
      </span>
    </el-dialog>

    <el-button :id="btn_select" type="primary" size="small"><i class="wl-icon-shangchuan"></i>本地上传</el-button>
    <!-- <el-button  type="primary" size="small">批量删除</el-button> -->
  </div>
</template>

// <script>
//   import {
//     getAliyunOSSSignature
//   } from "api/v1";
  export default {
    name: "aliyun-oss",
    props: {
      extensions: {
        type: String,
        default: ""
      },
      url: {
        type: String,
        required: true
      },
      courseId: {
        type: String,
        required: true
      },
      courseName: {
        type: String,
        required: true
      },
      folderId: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      ispartner: {
        type: Number,
        default: 0
      },
      schoolcoursetypeid: {
        type: String,
        default: ""
      },
      handlePreview: Function
    },
    data() {
      return {
        visible: false, // 是否显示上传对话框
        randomId: "oss_" + parseInt(Math.random() * 1000000),
        btn_select: "btn-" + parseInt(Math.random() * 1000000),
        btn_start: "btn-" + parseInt(Math.random() * 1000000),
        uploader: null,
        files: [],
        accessid: "",
        accesskey: "",
        host: "",
        userid: "",
        name: "",
        randomName: "",
        policy: "",
        signature: "",
        filename: "",
        key: "",
        callback: "",
        expire: 0,
        file_name: "",
        file_name_type: "local_name",
        already: false,
        userId: ["lmlam6pl5vextozukig", "abnam6pfq1ngyeom3cnyw", "0j4cadwpvz5o4lfqshzreg"],
        flieNumber:0,
      };
    },
    watch: {
      "files.length": function () {
        if (this.files.length === 0) {
          this.visible = false;
        }
      }
    },
    mounted() {
      // 初始化插件
      this.$nextTick(() => {
        this.initialize();
      });
    },
    beforeDestroy() {
      // 移除所有文件
      this.doRemoveAllFiles();
      this.uploader.destroy();
    },
    computed: {
      auth() {
        let auth = this.$store.state.auth || {};
        return auth;
      }
    },
    methods: {
      handleClick(file) {
        this.handlePreview && this.handlePreview(file);
      },
      onBeforeCloseHandler() {
        // 移除所有文件
        this.doRemoveAllFiles();
      },
      onStartHandler() {
        this.flieNumber=this.files.length;
        // console.log("文件数组长度:" + this.files.length);
        var isexit = this.userId.indexOf(this.auth.userId);
        if (this.files.length > 5 && isexit == -1) {
          this.$message("一次最多上传5个文件");
          return false;
        }
        if (this.uploader) {
          this.setUploadParam(this.uploader, "", false);
        }
      },
      doRemoveAllFiles() {
        for (let i = this.files.length - 1; i >= 0; i--) {
          this.uploader.removeFile(this.files[i]);
          this.files.splice(i, 1);
        }
      },
      doRemoveFielHandler(file) {
        let f = this.uploader.removeFile(file);
        if (f) {
          for (let i = this.files.length - 1; i >= 0; i--) {
            if (this.files[i].id === file.id) {
              this.files.splice(i, 1);
            }
          }
        }
        this.$emit("remove", file);
      },
      initialize() {
        let msg = this.extensions && this.extensions.length ? this.extensions :
          "jpg,jpeg,gif,png,bmp,mp4,txt,pdf,ppt,pptx,doc,docx,rar,zip,7z,mp3,swf,ziph";
        const self = this;
        this.uploader = new plupload.Uploader({
          runtimes: "html5,flash,silverlight,html4",
          browse_button: this.btn_select,
          // multi_selection: false,
          // container: document.getElementById(this.randomId),
          flash_swf_url: "/assets/lib/AliyunOSS/Moxie.swf",
          silverlight_xap_url: "/assets/lib/AliyunOSS/Moxie.xap",
          url: location.protocol + "//oss.aliyuncs.com",
          filters: {
            mime_types: [
              // 只允许上传图片和zip,rar文件
              {
                title: "只允许上传jpg,jpeg,gif,png,mp4,txt,pdf,ppt,pptx,doc,docx,rar,zip,7z,mp3,xlsx,xls资源",
                extensions: this.extensions && this.extensions.length ? this.extensions : "jpg,jpeg,gif,png,mp4,txt,pdf,ppt,pptx,doc,docx,rar,zip,7z,mp3,swf,ziph,xlsx,xls"
              }
              // { title: "Zip files", extensions: "zip,rar" }
            ],
            max_file_size: "2048mb", // 最大只能上传2048mb的文件
            prevent_duplicates: true // 不允许选取重复文件
          },
          init: {
            PostInit: function () {
              // document.getElementById('postfiles').onclick = function () {
              //   this.set_upload_param(this.uploader, '', false);
              //   return false;
              // };
            },
            FilesAdded: function (up, files) {
              plupload.each(files, function (file) {
                self.files.push(file);
              });
              if (this.files.length) {
                self.visible = true;
              }
            },
            BeforeUpload: function (up, file) {
              self.setUploadParam(up, file.name, true);
            },
            UploadProgress: function (up, file) {
              //
            },
            FileUploaded: function (up, file, info) {
              if (info.status == 200) {} else {
                self.$message.info(info.response);
              }
            },
            UploadComplete: function (up, file) {
              self.$nextTick(function () {
                // 隐藏上传框
                self.visible = false;
                // 清空上传文件队列
                self.files.length = 0;
                let name=this.flieNumber==1?'文件上传成功':'所有文件均上传成功';
                self.$message.success(name);
                
                self.$emit("done");
              });
            },
            Error: function (up, err) {
              if (err.code == plupload.FILE_SIZE_ERROR) {
                self.$message.error("选择的文件太大了, 最大支持文件大小2GB");
              } else if (err.code == plupload.FILE_EXTENSION_ERROR) {
                self.$message.error("仅支持" + msg + "文件");
                // self.$message.error("仅支持.jpg、.jpeg、.png、.gif、.mp4、文件");
              } else if (err.code == plupload.FILE_DUPLICATE_ERROR) {
                self.$message.error("这个文件已经选择或者上传过了");
              } else {
                self.$message.error(err.response);
              }
            }
          }
        });
        // 初始化上传插件
        this.uploader.init();
      },
      setUploadParam(up, filename, ret) {
        if (!ret) {
          let timestamp = Date.parse(new Date()) / 1000;
          if (this.expire < timestamp + 3) {
            this.getSignature().then(rst => {
              up.start();
            });
          } else {
            up.start();
          }
        } else {
          let new_multipart_params = {
            key: this.key + this.randomString(16) + this.getFileSuffix(filename),
            policy: this.policy,
            OSSAccessKeyId: this.accessid,
            success_action_status: "200", // 让服务端返回200,不然，默认会返回204
            callback: this.callback,
            signature: this.signature,
            "x:userid": this.userid,
            "x:name": this.changeDocExtension(filename),
            "x:courseid": this.courseId,
            "x:coursename": this.courseName,
            "x:folderid": this.folderId,
            "x:ispartner": this.ispartner,
            "x:schoolcoursetypeid": this.schoolcoursetypeid
          };
          up.setOption({
            url: this.host.replace(/^http:/, location.protocol), // 替换当前协议
            multipart_params: new_multipart_params
          });
        }
      },
      getUploadedFileName(filename) {
        if (this.file_name_type === "local_name") {
          let tmp_name = this.file_name;
          tmp_name = tmp_name.replace("${filename}", filename);
          return tmp_name;
        } else if (this.file_name_type === "random_name") {
          return this.file_name;
        }
        return;
      },
      getFileSuffix(filename) {
        console.log("filename:" + filename);
        let pos = filename.lastIndexOf(".");
        let suffix = "";
        if (pos !== -1) {
          suffix = filename.substring(pos).toLowerCase();
        }
        return suffix;
      },
      randomString(len) {
        len = len || 32;
        let chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
        let maxPos = chars.length;
        let pwd = "";
        for (let i = 0; i < len; i++) {
          pwd += chars.charAt(Math.floor(Math.random() * maxPos));
        }
        return pwd;
      },
      getSignature() {
        // 可以判断当前expire是否超过了当前时间, 如果超过了当前时间,就重新取一下.3s 做为缓冲
        let timestamp = Date.parse(new Date()) / 1000;
        if (this.expire < timestamp + 3) {
          return this.$http.get(this.url).then(rst => {
            this.host = rst.host;
            this.policy = rst.policy;
            this.accessid = rst.accessid;
            this.signature = rst.signature;
            this.expire = Date.parse(new Date(rst.expire)) / 1000;
            this.callback = rst.callback;
            this.key = rst.dir;
            (this.userid = rst.userid),
            (this.name = rst.name),
            (this.randomName = rst.random);

            return false;
          });
        }
        return Promise.resolve(true);
      },

      //改变文件后缀
      changeDocExtension(key) {
        if (key == "") {
          return key;
        } else {
          var s = key.lastIndexOf(".");
          var extension = key.substring(s + 1).toLowerCase();
          return key.substring(0, s + 1) + extension;
        }
      }
    }
  };

</script>
<style lang="scss">
  .aliyun-oss {
    .wl-icon-shangchuan {
      color: #109eff;
      margin-right: 5px;
      font-size: 17px;
    }
  }

</style>
